import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `고독사 유품정리 요청드렸는데
힘들고 어려운 일을 꼼꼼히 깔끔하게
해주셔서 정말 감사했어요 ~`,
    },
    {
      src: "/images/review2.png",
      txt: `이사가는김에 버리는 물건들 싹
정리하려고 요청드렸는데
깔끔하게 잘 해주셨습니다`,
    },
    {
      src: "/images/review3.png",
      txt: `아버님이 요양병원에 입원하시게
되어 집정리를 요청드렸는데
잘 정리해주셔서 감사했습니다.`,
    },
    {
      src: "/images/review4.png",
      txt: `세입자가 잠수타버려서
짐들을 처리하기가 정말 곤란했는데
오셔서 싹 정리해주셨어요`,
    },
    {
      src: "/images/review5.png",
      txt: `저번에 한번 요청드렸는데
너무 만족스럽게 잘해주셔서
한번더 요청드렸답니다.`,
    },
    {
      src: "/images/review6.png",
      txt: `저장강박증이 있는 동생의 집을
정리해달라고 요청드렸는데
진짜 깔끔하게 잘해주셨답니다.`,
    },
    {
      src: "/images/review7.png",
      txt: `돌아가신 어머님의 집을 정리해달라는
유품정리 요청을 드렸는데
정성껏 잘해주셔서 감사했습니다.`,
    },
    {
      src: "/images/review8.png",
      txt: `쓰레기집정리 요청을 드렸는데
싹 정리해주시는 것도 좋았고
거주청소 개념의 청소도 좋았습니다.`,
    },
    {
      src: "/images/review9.png",
      txt: `원룸정리 요청드렸는데
생각보다 잘해주셔서 놀랬습니다.
감사합니다.`,
    },
    {
      src: "/images/review10.png",
      txt: `쓰레기집정리 요청을 드렸는데
상담부터 정리까지 너무 잘해주셔서
정말정말 감사했습니다.`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <h2 className="font-medium">
          <span className="text-primary">싹!&nbsp;치워드림</span>
          을&nbsp;이용해주신 고객님들의 솔직한&nbsp;리뷰
        </h2>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0 "
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/iconStar.png"
                  alt="고객 만족도 별점"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-[calc(100%-40px)] min-h-72 p-3 rounded-2xl bg-white border shadow-md">
                <img
                  className="relative w-full h-auto object-cover object-center rounded-3xl"
                  src={v.src}
                  alt={`싹치워드림 이용 고객 리뷰 후기 ${i + 1}`}
                />
                <div className=" relative w-full h-fit text-center pt-5">
                  <p>{v.txt}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
